import React from "react";
import PropTypes from "prop-types";
import { productImageThumbnailPath } from "../../../utils/product.util";
import { Link } from "react-router";
import CartDeleteBtn from "../../../molecules/components/CartDeleteBtn";
import CartQuantityInput from "../../../molecules/containers/CartQuantityInput";

const CartListItem = ({
  cartProduct,
  deleteCartProduct,
  enableToManipulate,
  currencySign,
  labelDeleteItem,
  labelQuantity,
  labelDiscount,
  labelPrice,
  labelTotal,
  openModal
}) => (
  <div className="row summary_row mt-1 mb-1">
    <div className="col-12 col-md-5">
      <div className="media">
        <img
          className="align-self-start mr-3 product-image"
          src={productImageThumbnailPath(cartProduct.image, cartProduct.id, cartProduct.imageType)}
          alt={cartProduct.title}
          onClick={() => openModal(cartProduct.id)}
        />
        <div className="media-body">
          <div
            className="mt-0 product-title"
            onClick={() => openModal(cartProduct.id)}
          >
            {cartProduct.title}
          </div>
          <div className="product-subtitle">
            <small className="mt-0">
              <b>{cartProduct.code}</b>
            </small>
            &nbsp;
            <small className="mt-0">({cartProduct.ean})</small>
          </div>
          <div className="product-action">
            <button>{labelDeleteItem}</button>
          </div>
        </div>
      </div>
    </div>
    <div className="col-3 col-md-1 cart-property">
      <small>{labelQuantity}</small>
      <br />
      {enableToManipulate ? (
        <CartQuantityInput
          quantity={cartProduct.quantity}
          cartProduct={cartProduct}
        />
      ) : (
        cartProduct.quantity
      )}
    </div>
    <div className="col-3 col-md-2 cart-property">
      <small>{labelDiscount}</small>
      <br />
      {cartProduct.discount} %
    </div>
    <div className="col-3 col-md-2 cart-property">
      <small>{labelPrice}</small>
      <br />
      {parseFloat(cartProduct.price).toFixed(2)} {currencySign}
    </div>
    <div className="col-3 col-md-2 cart-property">
      <small>{labelTotal}</small>
      <br />
      {parseFloat(
        cartProduct.quantity *
          cartProduct.price *
          (cartProduct.discount > 0 ? 1 - cartProduct.discount / 100 : 1)
      ).toFixed(2)}{" "}
      {currencySign}
    </div>
  </div>
);

CartListItem.propTypes = {
  cartProduct: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      price: PropTypes.number,
      quantity: PropTypes.number,
      title: PropTypes.string,
      code: PropTypes.string,
      ean: PropTypes.string,
      discount: PropTypes.number
    })
  ).isRequired,
  deleteCartProduct: PropTypes.func.isRequired,
  enableToManipulate: PropTypes.bool,
  currencySign: PropTypes.string,
  labelDeleteItem: PropTypes.string,
  labelQuantity: PropTypes.string,
  labelDiscount: PropTypes.string,
  labelPrice: PropTypes.string,
  labelTotal: PropTypes.string
};

export default CartListItem;



// WEBPACK FOOTER //
// ./src/routes/CartList/components/CartListItem.js